import { Configuration, DocumentApi, DocumentSignatureApi } from '@stb-remittance/document-specs';

const packageJson = require('../../package.json');

const config = new Configuration({
  basePath: `${process.env.REACT_APP_API_URL}/api/document`,
  headers: {
    'X-App-Version': packageJson.version,
    'X-App-Origin': 'DASHBOARD',
  },
});
const documentApi = new DocumentApi(config);
const documentSignatureApi = new DocumentSignatureApi(config);

export const getDocumentStatus = (signLinkId: string) => {
  return documentApi.getDocumentStatus({ signLinkId });
};

export const getDocumentPdf = (signLinkId: string) => {
  return documentApi.getDocumentPdf({ signLinkId });
};

export const uploadDocumentSignature = (signLinkId: string, signature: Blob) => {
  return documentSignatureApi.uploadDocumentSignature({ signLinkId, signature });
};
